/**
 * Country → Cities/Towns data for autocomplete dropdowns.
 * Focuses on the UK (primary market) with major cities for other countries.
 */

const countryCityData = {
    'United Kingdom': [
        'Aberdeen', 'Abergavenny', 'Abingdon', 'Accrington', 'Airdrie',
        'Aldershot', 'Alfreton', 'Alloa', 'Alnwick', 'Amersham',
        'Andover', 'Arbroath', 'Ashford', 'Ashton-under-Lyne', 'Aylesbury',
        'Ayr', 'Banbury', 'Bangor', 'Barnsley', 'Barnstaple',
        'Barrow-in-Furness', 'Barry', 'Basildon', 'Basingstoke', 'Bath',
        'Batley', 'Bedford', 'Belfast', 'Berwick-upon-Tweed', 'Beverley',
        'Bexhill-on-Sea', 'Bicester', 'Billericay', 'Birkenhead', 'Birmingham',
        'Bishop Auckland', 'Blackburn', 'Blackpool', 'Blyth', 'Bodmin',
        'Bognor Regis', 'Bolton', 'Bootle', 'Boston', 'Bournemouth',
        'Bracknell', 'Bradford', 'Braintree', 'Brentwood', 'Bridgend',
        'Bridgwater', 'Bridlington', 'Brighouse', 'Brighton', 'Bristol',
        'Broadstairs', 'Bromley', 'Bromsgrove', 'Burnham-on-Sea', 'Burnley',
        'Burton upon Trent', 'Bury', 'Bury St Edmunds', 'Buxton', 'Caernarfon',
        'Caerphilly', 'Camberley', 'Cambridge', 'Cannock', 'Canterbury',
        'Cardiff', 'Carlisle', 'Carmarthen', 'Castleford', 'Chatham',
        'Chelmsford', 'Cheltenham', 'Chesham', 'Chester', 'Chesterfield',
        'Chichester', 'Chippenham', 'Chorley', 'Christchurch', 'Cirencester',
        'Clacton-on-Sea', 'Clevedon', 'Clitheroe', 'Coalville', 'Coatbridge',
        'Colchester', 'Coleraine', 'Congleton', 'Consett', 'Corby',
        'Coventry', 'Cramlington', 'Crawley', 'Crewe', 'Cromer',
        'Crowborough', 'Croydon', 'Cumbernauld', 'Cwmbran', 'Darlington',
        'Dartford', 'Dartmouth', 'Daventry', 'Deal', 'Derby',
        'Derry', 'Dewsbury', 'Didcot', 'Diss', 'Doncaster',
        'Dorchester', 'Dorking', 'Dover', 'Downpatrick', 'Droitwich',
        'Dudley', 'Dumbarton', 'Dumfries', 'Dundee', 'Dunfermline',
        'Dunstable', 'Durham', 'East Grinstead', 'East Kilbride', 'Eastbourne',
        'Eastleigh', 'Edinburgh', 'Elgin', 'Ellesmere Port', 'Ely',
        'Enfield', 'Enniskillen', 'Epping', 'Epsom', 'Evesham',
        'Exeter', 'Exmouth', 'Falkirk', 'Falmouth', 'Fareham',
        'Farnborough', 'Farnham', 'Faversham', 'Felixstowe', 'Fleetwood',
        'Folkestone', 'Fraserburgh', 'Frome', 'Gainsborough', 'Gateshead',
        'Gillingham', 'Glasgow', 'Glastonbury', 'Glossop', 'Gloucester',
        'Godalming', 'Goole', 'Grantham', 'Gravesend', 'Grays',
        'Great Yarmouth', 'Greenock', 'Grimsby', 'Guildford', 'Guisborough',
        'Halesowen', 'Halifax', 'Hamilton', 'Harlow', 'Harpenden',
        'Harrogate', 'Hartlepool', 'Haslemere', 'Hastings', 'Hatfield',
        'Havant', 'Haverfordwest', 'Hawick', 'Haywards Heath', 'Heanor',
        'Hemel Hempstead', 'Henley-on-Thames', 'Hereford', 'Hertford', 'Hexham',
        'High Wycombe', 'Hinckley', 'Hitchin', 'Hoddesdon', 'Holmfirth',
        'Honiton', 'Horsham', 'Hove', 'Huddersfield', 'Hull',
        'Huntingdon', 'Hyde', 'Hythe', 'Ilford', 'Ilkeston',
        'Ilkley', 'Immingham', 'Inverness', 'Ipswich', 'Irvine',
        'Jarrow', 'Keighley', 'Kendal', 'Kenilworth', 'Kettering',
        'Kidderminster', 'Kilmarnock', 'King\'s Lynn', 'Kingsbridge', 'Kingston upon Thames',
        'Kingswood', 'Kirkcaldy', 'Kirkwall', 'Knaresborough', 'Knottingley',
        'Lancaster', 'Larne', 'Leamington Spa', 'Leeds', 'Leicester',
        'Leigh', 'Leighton Buzzard', 'Leominster', 'Lerwick', 'Lewes',
        'Lichfield', 'Lincoln', 'Lisburn', 'Littlehampton', 'Liverpool',
        'Livingston', 'Llandrindod Wells', 'Llandudno', 'Llanelli', 'London',
        'Long Eaton', 'Loughborough', 'Louth', 'Lowestoft', 'Ludlow',
        'Luton', 'Lymington', 'Macclesfield', 'Maesteg', 'Magherafelt',
        'Maidenhead', 'Maidstone', 'Maldon', 'Malton', 'Malvern',
        'Manchester', 'Mansfield', 'March', 'Margate', 'Market Harborough',
        'Matlock', 'Melton Mowbray', 'Merthyr Tydfil', 'Middlesbrough', 'Mildenhall',
        'Milford Haven', 'Milton Keynes', 'Minehead', 'Mirfield', 'Mold',
        'Morecambe', 'Morpeth', 'Motherwell', 'Nailsea', 'Nantwich',
        'Neath', 'Nelson', 'Newark-on-Trent', 'Newbury', 'Newcastle upon Tyne',
        'Newcastle-under-Lyme', 'Newmarket', 'Newport', 'Newquay', 'Newton Abbot',
        'Newton Aycliffe', 'Newtown', 'Newtownabbey', 'Normanton', 'Northallerton',
        'Northampton', 'Northwich', 'Norwich', 'Nottingham', 'Nuneaton',
        'Oakham', 'Oldham', 'Omagh', 'Ormskirk', 'Ossett',
        'Oswestry', 'Otley', 'Oxford', 'Paignton', 'Paisley',
        'Peebles', 'Pembroke', 'Penarth', 'Penrith', 'Penzance',
        'Perth', 'Peterborough', 'Peterhead', 'Peterlee', 'Petersfield',
        'Pickering', 'Plymouth', 'Pontefract', 'Pontypridd', 'Poole',
        'Port Talbot', 'Portadown', 'Porthcawl', 'Portland', 'Portsmouth',
        'Potters Bar', 'Preston', 'Prestwick', 'Princes Risborough', 'Pudsey',
        'Ramsgate', 'Rawtenstall', 'Rayleigh', 'Reading', 'Redcar',
        'Redditch', 'Redhill', 'Redruth', 'Reigate', 'Retford',
        'Rhyl', 'Richmond', 'Rickmansworth', 'Ripley', 'Ripon',
        'Rochdale', 'Rochester', 'Romford', 'Romsey', 'Ross-on-Wye',
        'Rossendale', 'Rotherham', 'Rothesay', 'Royston', 'Rugby',
        'Rugeley', 'Runcorn', 'Rushden', 'Ryde', 'Rye',
        'Saffron Walden', 'Sale', 'Salford', 'Salisbury', 'Saltburn-by-the-Sea',
        'Sandbach', 'Scarborough', 'Scunthorpe', 'Seaford', 'Selby',
        'Settle', 'Sevenoaks', 'Sheffield', 'Shepshed', 'Shepton Mallet',
        'Sherborne', 'Sheringham', 'Shipley', 'Shrewsbury', 'Sidmouth',
        'Sittingbourne', 'Skegness', 'Skipton', 'Sleaford', 'Slough',
        'Solihull', 'South Shields', 'Southampton', 'Southend-on-Sea', 'Southport',
        'Spalding', 'St Albans', 'St Andrews', 'St Austell', 'St Helens',
        'St Ives', 'St Neots', 'Stafford', 'Staines', 'Stalybridge',
        'Stamford', 'Stevenage', 'Stirling', 'Stockport', 'Stockton-on-Tees',
        'Stoke-on-Trent', 'Stone', 'Stourbridge', 'Stowmarket', 'Stranraer',
        'Stratford-upon-Avon', 'Stroud', 'Sudbury', 'Sunderland', 'Sutton Coldfield',
        'Sutton-in-Ashfield', 'Swadlincote', 'Swanage', 'Swanley', 'Swansea',
        'Swindon', 'Tadcaster', 'Tamworth', 'Taunton', 'Tavistock',
        'Telford', 'Tenby', 'Tewkesbury', 'Thame', 'Thetford',
        'Thirsk', 'Thornaby-on-Tees', 'Thorne', 'Tipton', 'Tiverton',
        'Todmorden', 'Tonbridge', 'Torquay', 'Totnes', 'Towcester',
        'Tredegar', 'Tring', 'Troon', 'Trowbridge', 'Truro',
        'Tunbridge Wells', 'Uckfield', 'Ulverston', 'Uttoxeter', 'Uxbridge',
        'Wakefield', 'Wallingford', 'Wallsend', 'Walsall', 'Waltham Abbey',
        'Wantage', 'Ware', 'Wareham', 'Warminster', 'Warrington',
        'Warwick', 'Washington', 'Watford', 'Wednesbury', 'Wellingborough',
        'Wellington', 'Wells', 'Welshpool', 'Welwyn Garden City', 'West Bromwich',
        'Weston-super-Mare', 'Wetherby', 'Weymouth', 'Whitby', 'Whitehaven',
        'Whitstable', 'Wick', 'Widnes', 'Wigan', 'Wigton',
        'Willenhall', 'Wimborne Minster', 'Winchester', 'Windermere', 'Windsor',
        'Winsford', 'Wisbech', 'Witham', 'Witney', 'Woking',
        'Wokingham', 'Wolverhampton', 'Woodbridge', 'Worcester', 'Workington',
        'Worksop', 'Worthing', 'Wrexham', 'Wymondham', 'Yarm',
        'Yeovil', 'York',
    ],
    'Ireland': [
        'Athlone', 'Bray', 'Carlow', 'Castlebar', 'Cavan',
        'Clonmel', 'Cork', 'Drogheda', 'Dublin', 'Dundalk',
        'Dungarvan', 'Ennis', 'Galway', 'Kilkenny', 'Killarney',
        'Letterkenny', 'Limerick', 'Longford', 'Mallow', 'Mullingar',
        'Naas', 'Navan', 'Nenagh', 'Newbridge', 'Portlaoise',
        'Roscommon', 'Sligo', 'Swords', 'Thurles', 'Tipperary',
        'Tralee', 'Tullamore', 'Waterford', 'Wexford', 'Wicklow',
    ],
    'United States': [
        'Albuquerque', 'Anchorage', 'Arlington', 'Atlanta', 'Austin',
        'Baltimore', 'Boston', 'Charlotte', 'Chicago', 'Cleveland',
        'Colorado Springs', 'Columbus', 'Dallas', 'Denver', 'Detroit',
        'El Paso', 'Fort Worth', 'Fresno', 'Henderson', 'Houston',
        'Indianapolis', 'Jacksonville', 'Kansas City', 'Las Vegas', 'Long Beach',
        'Los Angeles', 'Louisville', 'Memphis', 'Mesa', 'Miami',
        'Milwaukee', 'Minneapolis', 'Nashville', 'New Orleans', 'New York',
        'Newark', 'Oakland', 'Oklahoma City', 'Omaha', 'Orlando',
        'Philadelphia', 'Phoenix', 'Pittsburgh', 'Portland', 'Raleigh',
        'Sacramento', 'San Antonio', 'San Diego', 'San Francisco', 'San Jose',
        'Seattle', 'Tampa', 'Tucson', 'Virginia Beach', 'Washington',
    ],
    'Canada': [
        'Brampton', 'Burlington', 'Burnaby', 'Calgary', 'Edmonton',
        'Halifax', 'Hamilton', 'Kitchener', 'Laval', 'London',
        'Markham', 'Mississauga', 'Montreal', 'Ottawa', 'Quebec City',
        'Regina', 'Richmond', 'Saskatoon', 'Surrey', 'Toronto',
        'Vancouver', 'Victoria', 'Windsor', 'Winnipeg',
    ],
    'Australia': [
        'Adelaide', 'Brisbane', 'Cairns', 'Canberra', 'Darwin',
        'Geelong', 'Gold Coast', 'Hobart', 'Melbourne', 'Newcastle',
        'Perth', 'Sunshine Coast', 'Sydney', 'Toowoomba', 'Townsville',
        'Wollongong',
    ],
    'New Zealand': [
        'Auckland', 'Christchurch', 'Dunedin', 'Hamilton', 'Hastings',
        'Invercargill', 'Lower Hutt', 'Napier', 'Nelson', 'New Plymouth',
        'Palmerston North', 'Rotorua', 'Tauranga', 'Upper Hutt', 'Wellington',
        'Whangarei',
    ],
    'Germany': [
        'Berlin', 'Bremen', 'Cologne', 'Dortmund', 'Dresden',
        'Dusseldorf', 'Essen', 'Frankfurt', 'Hamburg', 'Hanover',
        'Leipzig', 'Munich', 'Nuremberg', 'Stuttgart',
    ],
    'France': [
        'Bordeaux', 'Lille', 'Lyon', 'Marseille', 'Montpellier',
        'Nantes', 'Nice', 'Paris', 'Rennes', 'Strasbourg',
        'Toulouse',
    ],
    'Spain': [
        'Barcelona', 'Bilbao', 'Granada', 'Las Palmas', 'Madrid',
        'Malaga', 'Murcia', 'Palma de Mallorca', 'Seville', 'Valencia',
        'Zaragoza',
    ],
    'Italy': [
        'Bologna', 'Florence', 'Genoa', 'Milan', 'Naples',
        'Palermo', 'Rome', 'Turin', 'Venice', 'Verona',
    ],
    'Netherlands': [
        'Amsterdam', 'Breda', 'Eindhoven', 'Groningen', 'Haarlem',
        'Rotterdam', 'The Hague', 'Tilburg', 'Utrecht',
    ],
    'Portugal': [
        'Braga', 'Coimbra', 'Faro', 'Funchal', 'Lisbon',
        'Porto', 'Setúbal',
    ],
    'South Africa': [
        'Bloemfontein', 'Cape Town', 'Durban', 'East London', 'Johannesburg',
        'Kimberley', 'Nelspruit', 'Pietermaritzburg', 'Polokwane', 'Port Elizabeth',
        'Pretoria', 'Rustenburg',
    ],
    'United Arab Emirates': [
        'Abu Dhabi', 'Ajman', 'Al Ain', 'Dubai', 'Fujairah',
        'Ras al-Khaimah', 'Sharjah',
    ],
    'India': [
        'Ahmedabad', 'Bangalore', 'Chennai', 'Delhi', 'Hyderabad',
        'Jaipur', 'Kolkata', 'Lucknow', 'Mumbai', 'Pune',
    ],
    'Singapore': [
        'Singapore',
    ],
    'Hong Kong': [
        'Hong Kong',
    ],
    'Sweden': [
        'Gothenburg', 'Malmo', 'Stockholm', 'Uppsala',
    ],
    'Norway': [
        'Bergen', 'Oslo', 'Stavanger', 'Trondheim',
    ],
    'Denmark': [
        'Aarhus', 'Copenhagen', 'Odense',
    ],
    'Belgium': [
        'Antwerp', 'Brussels', 'Ghent', 'Liège',
    ],
    'Switzerland': [
        'Basel', 'Bern', 'Geneva', 'Lausanne', 'Zurich',
    ],
    'Austria': [
        'Graz', 'Innsbruck', 'Linz', 'Salzburg', 'Vienna',
    ],
    'Poland': [
        'Gdansk', 'Krakow', 'Lodz', 'Poznan', 'Warsaw', 'Wroclaw',
    ],
    'Greece': [
        'Athens', 'Heraklion', 'Patras', 'Thessaloniki',
    ],
    'Japan': [
        'Fukuoka', 'Kyoto', 'Nagoya', 'Osaka', 'Sapporo', 'Tokyo', 'Yokohama',
    ],
    'South Korea': [
        'Busan', 'Daegu', 'Incheon', 'Seoul',
    ],
    'China': [
        'Beijing', 'Guangzhou', 'Shanghai', 'Shenzhen',
    ],
    'Brazil': [
        'Belo Horizonte', 'Brasilia', 'Curitiba', 'Fortaleza', 'Porto Alegre',
        'Recife', 'Rio de Janeiro', 'Salvador', 'São Paulo',
    ],
    'Mexico': [
        'Guadalajara', 'Mexico City', 'Monterrey', 'Puebla', 'Tijuana',
    ],
};

/** Sorted list of all country names */
export const countries = Object.keys(countryCityData).sort();

/**
 * Get cities/towns for a given country.
 * Returns an empty array if the country isn't in our dataset.
 */
export const getCitiesForCountry = (country) => {
    if (!country) return [];
    return countryCityData[country] || [];
};

export default countryCityData;
